/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Save_ConfirmInputs */

const en_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const fr_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder`)
};

const de_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const ru_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранять`)
};

const es_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorrar`)
};

const zh_cn2_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省`)
};

const ja_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const hi_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाना`)
};

const pt_pt2_subtitle_export_preset_save_confirm = /** @type {(inputs: Subtitle_Export_Preset_Save_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Subtitle_Export_Preset_Save_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_save_confirm = /** @type {((inputs?: Subtitle_Export_Preset_Save_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Save_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_save_confirm(inputs)
	if (locale === "de") return de_subtitle_export_preset_save_confirm(inputs)
	if (locale === "it") return it_subtitle_export_preset_save_confirm(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_save_confirm(inputs)
	if (locale === "es") return es_subtitle_export_preset_save_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_save_confirm(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_save_confirm(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_save_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_save_confirm(inputs)
	return en_subtitle_export_preset_save_confirm(inputs)
});